var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"verify-code-btn mobile-email-btn",attrs:{"type":"primary","size":"mini"},on:{"click":_vm.getVerifyCode}},[_vm._v("获取验证码"+_vm._s(_vm.verifyCodeTime>0?("(" + _vm.verifyCodeTime + ")"):''))])}
var staticRenderFns = []

export { render, staticRenderFns }